<template>
  <div class="tab-setting-detail">
    <div v-if="isActiveTitle" class="tab-setting-detail__title">
      Change your details
    </div>
    <div class="tab-setting-detail__inputs">
      <b-row class="tab-setting-detail__input">
        <b-col cols="3" class="tab-setting-detail__input-label">
          <label>First Name</label>
        </b-col>
        <b-col cols="9" class="tab-setting-detail__input-item">
          <b-form-input v-model="firstName" />
        </b-col>
      </b-row>
      <b-row class="tab-setting-detail__input">
        <b-col cols="3" class="tab-setting-detail__input-label">
          <label>Last Name</label>
        </b-col>
        <b-col cols="9" class="tab-setting-detail__input-item">
          <b-form-input v-model="lastName" />
        </b-col>
      </b-row>
    </div>
    <hr v-if="isActiveTitle">
    <div class="tab-setting-detail__button">
      <b-button @click="handleSaveMyDetails">SUBMIT</b-button>
    </div>
  </div>
</template>

<script>
import accountService from '@/services/account.service';
export default {
  props: {
    isActiveTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      firstName: '',
      lastName: ''
    }
  },
  created() {
    accountService.myDetails().then((res) => {
      if (res) {
        this.firstName = res.first_name;
        this.lastName = res.last_name;
      }
    });
  },
  methods: {
    handleSaveMyDetails() {
      accountService.saveMyDetails(this.firstName, this.lastName).then((res) => {
        if (res.status === 'success') {
          this.$bvToast.toast('Your details updated', {
            title: 'Successfully',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          })
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          })
        }
      },
        () => this.$bvToast.toast('Update failed! Please try again', {
          title: 'Failed',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
      }));
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/web/account/settings/_content.scss"/>
